import React, { useContext, useRef } from 'react';
import classes from './SecondaryNav.module.scss';
import { ButtonColorsEnum } from '../../constants/button-colors';
import { IconsEnum } from '../../constants/icons';
import { NavigationTabs } from './NavigationTabs';
import { useTopNavVisibility } from '../../hooks/useTopNavVisibility';
import { useDimensions } from 'hooks/useDimensions';
import { NavigationTabsType } from './SecondaryNav.controller';
import classNames from 'classnames';
import { Button } from '../../components/actions/Button';
import { TopNavContext } from '../../providers/TopNavProvider';
import { PostSource } from '../../models/graphql';
import { useOpenPostEditor } from '../../hooks/useOpenPostEditor';

export type SecondaryNavViewProps = {
  Tabs: NavigationTabsType[];
};

export const SecondaryNavView = (props: SecondaryNavViewProps): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  const actionRef = useRef<HTMLDivElement>(null);
  const { openNewPost } = useOpenPostEditor();
  const { state } = useContext(TopNavContext);

  const { width } = useDimensions(containerRef);
  const splitBtnClasses = classNames({
    cell: true,
    shrink: true,
    [classes.ActionButton]: true
  });

  useTopNavVisibility('second');

  return (
    <>
      {props.Tabs && (
        <div className={classes.SecondaryNav} ref={containerRef}>
          <div className={'grid-x align-justify align-middle'}>
            <NavigationTabs
              containerWidth={width}
              actionElementWidth={actionRef.current ? actionRef.current.offsetWidth + 35 : 0}
              TabList={props.Tabs}
            />
            <div className={splitBtnClasses} ref={actionRef}>
              <Button
                action={() =>
                  openNewPost({
                    source: PostSource.TN,
                    onClose: state.newPostCloseCallback
                  })
                }
                color={ButtonColorsEnum.secondary}
                size={'medium'}
                type={'button'}
                variant={'solid'}
                icon={{ value: IconsEnum.plus, side: 'left' }}>
                New Post
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
